import { User, UserVerifiedStatus } from '~core/models/auth.models';
import { isBitMaskFlagSet } from '@veone/ngx-utilities/auth';
import { UserAccountInfo } from '~core/models/account.models';

export const addUserComputedProperties = (user: User): User => {
  const { lastName, firstName } = user;
  const fullName = lastName ? `${lastName} ${firstName || ''}` : null;
  return {
    ...user,
    ...(!!fullName && { fullName }),
    ...('propertiesVerified' in user && {
      emailVerified: isBitMaskFlagSet(
        user.propertiesVerified,
        UserVerifiedStatus.email
      ),
      phoneNumberVerified: isBitMaskFlagSet(
        user.propertiesVerified,
        UserVerifiedStatus.phoneNumber
      )
    })
  } as User;
};

export const addAccountInfoComputedProperties = (
  user: UserAccountInfo
): UserAccountInfo => {
  const { lastName, firstName } = user;
  const fullName = lastName ? `${lastName} ${firstName || ''}` : null;
  return {
    ...user,
    ...(!!fullName && { fullName }),
    ...('propertiesVerified' in user && {
      emailVerified: isBitMaskFlagSet(
        user.propertiesVerified,
        UserVerifiedStatus.email
      ),
      phoneNumberVerified: isBitMaskFlagSet(
        user.propertiesVerified,
        UserVerifiedStatus.phoneNumber
      )
    })
  };
};

export const userToUserAccountInfo = (user: User): UserAccountInfo => {
  return {
    username: user.username,
    email: user.email,
    phoneNumber: user.phoneNumber,
    propertiesVerified: user.propertiesVerified,
    countryCode: user.countryCode,
    city: user.city,
    lastName: user.lastName,
    phoneNumberVerified: user.phoneNumberVerified,
    emailVerified: user.emailVerified,
    enabledUpdatedAt: user.enabledUpdatedAt,
    enabled: user.enabled,
    locked: user.locked,
    securityChallenge: {
      type: 'none'
    }
  };
};
